module.exports = __webpack_public_path__ + "static/media/softCircle.265b55cc.jpg";